import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.sass']
})
export class NotFoundComponent {
  public title = null;
  public subTitle = 'Nenhum registro encontrado!';
  public icon = 'fas fa-info';

  @Input('title')
  public set setTitle(text: string) {
    if (text) { this.title = text; }
  }

  @Input('subTitle')
  public set setSubTitle(text: string) {
    if (text) { this.subTitle = text; }
  }

  @Input('icon')
  public set setIcon(icon: string) {
    if (icon) { this.icon = icon; }
  }
}
